import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Img from "gatsby-image";
import LinkButton from "./LinkButton";
import CallButton from "./CallButton";
import OverenaFirma from "./OverenaFirma";
import { useMediaQuery } from 'react-responsive';
import Ilustrace1 from "../../assets/img/ilustracePohreb1.svg";
import Ilustrace2 from "../../assets/img/ilustracePohreb2.svg";
import Ilustrace3 from "../../assets/img/ilustracePohreb3.svg";
import Ilustrace4 from "../../assets/img/ilustracepohreb4.svg";


const DalsiOdkazyInner = styled.div`
  background: #F4F3F0;
  padding: 60px 0;

  @media (max-width: 600px) {
    padding: 40px 0;
  }

  h2 {
    font-family: NewKansas;
    font-size: 36px;
    color: #2c4668;
    text-align: center;
    line-height: 50px;
    margin: 0 auto;
    margin-bottom: 50px;
    max-width: 1150px;
    width: calc(100% - 50px);

    @media (max-width: 899px) {
      font-size: 32px;
      line-height: 40px;
    }

    @media (max-width: 430px) {
      font-size: 28px;
      line-height: 35px;
      margin-bottom: 30px;
    }
  }

  .bubliny {
    display: grid;
    grid-template-columns: 250px 250px 250px 250px;
    column-gap: calc((100% - 250px*4)/3);
    row-gap: 40px;
    width: calc(100% - 100px);
    margin: 0 auto;
    max-width: 1150px;
    align-items: middle;

    @media (max-width: 1150px) {
      grid-template-columns: 300px 300px 300px;
      column-gap: calc((100% - 300px*3)/2);
      row-gap: 40px;
    }

    @media (max-width: 1050px) {
      grid-template-columns: 250px 250px 250px;
      column-gap: calc((100% - 250px*3)/2);
      row-gap: 40px;
    }

    @media (max-width: 900px) {
      grid-template-columns: auto;
      grid-template-columns: 100%;
      column-gap: 0;
      row-gap: 25px;
      width: calc(100% - 50px);
    }


    .bublina {
      background: #FFFFFF;
      box-shadow: 0 9px 20px 0 rgba(0,0,0,0.07);
      border-radius: 10px;
      padding: 15px;

      @media (max-width: 900px) {
        max-width: 400px;
        margin: 0 auto;
      }

      .fotka {
        border-radius: 5px;
        height: 100px;
        margin-bottom: 15px;
      }

      h3 {
        font-family: Visuelt-Medium;
        font-size: 18px;
        margin-bottom: 10px;
        color: #000000;

        a {
          color: #000000;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      p {
        font-family: Visuelt-Regular;
        font-size: 14px;
        color: #727272;
        line-height: 18px;
      }
    }
  }
  
`;



const DalsiOdkazy = ({data}) => {
  const isLess1000 = useMediaQuery({
    query: '(max-width: 1000px)'
  });

  const isLess899 = useMediaQuery({
    query: '(max-width: 899px)'
  });


  return (
    <DalsiOdkazyInner>
      <h2>Další užitečné stránky</h2>
      <div className="bubliny">
        {data.map(b => {
          return(
            <div key={b.link} className="bublina">
              <Link to={b.link}><Img className="fotka" alt={b.h4} fluid={b.img} /></Link>
              <h3><Link to={b.link}>{b.h4}</Link></h3>
              <p>{b.p}</p>
            </div>  
          );
        })}
      </div>
    </DalsiOdkazyInner>
  );
}

export default DalsiOdkazy;


